import { _ as _defineProperty, a as _inherits, b as _createClass, e as _classCallCheck, f as _callSuper } from '../_helpers/_rollupPluginBabelHelpers.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.object.values.js';
import { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import exceptionIcon from '@jetbrains/icons/exception';
import checkmarkIcon from '@jetbrains/icons/checkmark';
import warningIcon from '@jetbrains/icons/warning';
import closeIcon from '@jetbrains/icons/close';
import Icon from '../icon/icon.js';
import LoaderInline from '../loader-inline/loader-inline.js';
import { getRect } from '../global/dom.js';
import joinDataTestAttributes from '../global/data-tests.js';
import { Button } from '../button/button.js';
import { T as Theme, a as ThemeProvider } from '../_helpers/theme.js';
import { jsx, jsxs } from 'react/jsx-runtime';
export { default as Container } from './container.js';
import { Color } from '../icon/icon__constants.js';
import 'util-deprecate';
import '../_helpers/icon__svg.js';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import 'core-js/modules/es.string.starts-with.js';
import '../global/memoize.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.map.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.weak-map.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.array.reduce.js';
import 'core-js/modules/es.object.entries.js';
import 'core-js/modules/es.array.filter.js';
import 'core-js/modules/es.object.assign.js';
import 'core-js/modules/es.set.js';
import 'core-js/modules/es.string.split.js';
import 'core-js/modules/web.dom-collections.for-each.js';
import '@jetbrains/icons/chevron-down';
import '../link/clickableLink.js';
import '../global/controls-height.js';
import '../_helpers/button__classes.js';
import 'react-dom';
import '../popup/popup.target.js';
import '../popup/popup.js';
import 'core-js/modules/es.regexp.to-string.js';
import '../global/get-uid.js';
import '../global/schedule-raf.js';
import '../shortcuts/shortcuts.js';
import 'core-js/modules/es.array.map.js';
import '../shortcuts/core.js';
import 'core-js/modules/es.array.find-index.js';
import 'core-js/modules/es.array.includes.js';
import 'core-js/modules/es.array.slice.js';
import 'core-js/modules/es.array.splice.js';
import 'core-js/modules/es.string.includes.js';
import 'core-js/modules/es.string.match.js';
import 'combokeys';
import '../global/sniffer.js';
import 'sniffr';
import '../tab-trap/tab-trap.js';
import '../popup/position.js';
import 'core-js/modules/es.array.sort.js';
import '../popup/popup.consts.js';

var modules_e02b3280 = {"animation-duration":"300ms","animation-easing":"ease-out","light":"light_rui_2ac4","alert":"alert_rui_25ab","alertInline":"alertInline_rui_25ab","error":"error_rui_25ab","icon":"icon_rui_25ab","caption":"caption_rui_25ab","withCloseButton":"withCloseButton_rui_25ab","badge":"badge_rui_25ab","loader":"loader_rui_25ab","close":"close_rui_25ab","animationOpen":"animationOpen_rui_25ab","show":"show_rui_25ab","animationClosing":"animationClosing_rui_25ab","animationShaking":"animationShaking_rui_25ab","shaking":"shaking_rui_25ab"};

var ANIMATION_TIME = 500;
/**
 * @name Alert
 */
/**
 * List of available alert types.
 * @enum {string}
 */
var AlertType;
(function (AlertType) {
  AlertType["ERROR"] = "error";
  AlertType["MESSAGE"] = "message";
  AlertType["SUCCESS"] = "success";
  AlertType["WARNING"] = "warning";
  AlertType["LOADING"] = "loading";
})(AlertType || (AlertType = {}));
/**
 * Lookup table of alert type to icon modifier.
 * @type {Object.<AlertType, string>}
 */
var TypeToIcon = {
  [AlertType.ERROR]: exceptionIcon,
  [AlertType.SUCCESS]: checkmarkIcon,
  [AlertType.WARNING]: warningIcon
};
/**
 * Lookup table of alert type to icon color.
 * @type {Object.<AlertType, Icon.Color>}
 */
var TypeToIconColor = {
  [AlertType.ERROR]: Color.RED,
  [AlertType.SUCCESS]: Color.GREEN,
  [AlertType.WARNING]: Color.WHITE
};
/**
 * @constructor
 * @name Alert
 * @extends {ReactComponent}
 */
/**
 * **Alert** is a component for displaying contextual notifications. If you want to display a stack of notifications, use **Alerts** instead.
 */
var Alert = /*#__PURE__*/function (_PureComponent) {
  function Alert() {
    var _this;
    _classCallCheck(this, Alert);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Alert, [].concat(args));
    _defineProperty(_this, "state", {
      height: null
    });
    _defineProperty(_this, "node", void 0);
    _defineProperty(_this, "hideTimeout", void 0);
    _defineProperty(_this, "closeRequest", function (event) {
      _this.startCloseAnimation();
      return _this.props.onCloseRequest(event);
    });
    _defineProperty(_this, "startCloseAnimation", function () {
      var height = getRect(_this.node).height;
      _this.setState({
        height
      });
    });
    /**
     * @param {SyntheticEvent} evt
     * @private
     */
    _defineProperty(_this, "_handleCaptionsLinksClick", function (evt) {
      if (evt.target instanceof Element && evt.target.matches('a')) {
        _this.closeRequest(evt);
      }
    });
    _defineProperty(_this, "storeAlertRef", function (node) {
      _this.node = node;
    });
    return _this;
  }
  _inherits(Alert, _PureComponent);
  return _createClass(Alert, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.timeout > 0) {
        this.hideTimeout = window.setTimeout(this.closeRequest, this.props.timeout);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.isClosing) {
        this._close();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.hideTimeout);
    }
  }, {
    key: "_close",
    value: function _close() {
      var _this2 = this;
      this.startCloseAnimation();
      setTimeout(function () {
        _this2.props.onClose();
      }, ANIMATION_TIME);
    }
  }, {
    key: "_getCaption",
    value:
    /**
     * @private
     */
    function _getCaption() {
      return /*#__PURE__*/jsx("span", {
        className: classNames(modules_e02b3280.caption, this.props.captionClassName, {
          [modules_e02b3280.withCloseButton]: this.props.closeable
        }),
        onClick: this._handleCaptionsLinksClick
        // We only process clicks on `a` elements, see above
        ,
        role: "presentation",
        children: this.props.children
      });
    }
    /**
     * @private
     * @return {XML|string}
     */
  }, {
    key: "_getIcon",
    value: function _getIcon() {
      var glyph = TypeToIcon[this.props.type];
      if (glyph) {
        return /*#__PURE__*/jsx(Icon, {
          glyph: glyph,
          className: modules_e02b3280.icon,
          color: TypeToIconColor[this.props.type] || Color.DEFAULT
        });
      } else if (this.props.type === AlertType.LOADING) {
        return /*#__PURE__*/jsx(LoaderInline, {
          className: modules_e02b3280.loader
        });
      }
      return '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        type = _this$props.type,
        inline = _this$props.inline,
        isClosing = _this$props.isClosing,
        isShaking = _this$props.isShaking,
        closeButtonClassName = _this$props.closeButtonClassName,
        showWithAnimation = _this$props.showWithAnimation,
        className = _this$props.className,
        dataTest = _this$props['data-test'],
        theme = _this$props.theme;
      var classes = classNames(className, {
        [modules_e02b3280.alert]: true,
        [modules_e02b3280.animationOpen]: showWithAnimation,
        [modules_e02b3280.error]: type === 'error',
        [modules_e02b3280.alertInline]: inline,
        [modules_e02b3280.animationClosing]: isClosing,
        [modules_e02b3280.animationShaking]: isShaking
      });
      var height = this.state.height;
      var style = height ? {
        marginBottom: -height
      } : undefined;
      return /*#__PURE__*/jsxs(ThemeProvider, {
        theme: theme,
        className: classes,
        "data-test": joinDataTestAttributes('alert', dataTest),
        "data-test-type": type,
        style: style,
        ref: this.storeAlertRef,
        children: [this._getIcon(), this._getCaption(), this.props.closeable ? /*#__PURE__*/jsx(Button, {
          icon: closeIcon,
          className: classNames(modules_e02b3280.close, closeButtonClassName),
          "data-test": "alert-close",
          "aria-label": "close alert",
          onClick: this.closeRequest
        }) : '']
      });
    }
  }]);
}(PureComponent);
_defineProperty(Alert, "propTypes", {
  timeout: PropTypes.number,
  /**
   * Fires when alert starts closing if timeout is out or user clicks "Close" button
   */
  onCloseRequest: PropTypes.func,
  onClose: PropTypes.func,
  isShaking: PropTypes.bool,
  isClosing: PropTypes.bool,
  /**
   * Whether an alert is rendered inside an **Alerts** container
   * or standalone.
   */
  inline: PropTypes.bool,
  showWithAnimation: PropTypes.bool,
  closeable: PropTypes.bool,
  type: PropTypes.oneOf(Object.values(AlertType)),
  children: PropTypes.node,
  className: PropTypes.string,
  captionClassName: PropTypes.string,
  closeButtonClassName: PropTypes.string,
  'data-test': PropTypes.string
});
/** @override */
_defineProperty(Alert, "defaultProps", {
  theme: Theme.DARK,
  closeable: true,
  showWithAnimation: true,
  type: AlertType.MESSAGE,
  inline: true,
  isClosing: false,
  isShaking: false,
  timeout: 0,
  onClose: function onClose() {},
  onCloseRequest: function onCloseRequest() {}
});
_defineProperty(Alert, "Type", AlertType);

export { ANIMATION_TIME, AlertType, Alert as default };
